import { SignContractDialog } from '@/components/contracts/SignContractDialog';
import { Button } from '@/components/ui';
import { useTranslation } from '@kgc/i18n';
import { useState } from 'react';

/**
 * ReturnSignButton — P0-2 (FE-3 D4) bérlés-visszavételi átvételi-jegyzőkönyv aláírás.
 *
 * A meglévő, verifikált esign-stacket hasznosítja újra (ADR-099 `SignContractDialog` +
 * SignaturePad + 2-consent + submit), `sourceType='RENTAL_RETURN'`, `sourceId=rentalId`
 * (BE #489 post-sign → `Rental.returnSignedAt`). Az `InlineSignButton`-mintával ekvivalens,
 * DE NINCS get-or-create thin-call: a return esign forrás-id-ja MAGA a rentalId — a
 * `SignContractDialog` `createSigningSession`-je a `rental-return` mappinggel nyit sessiont.
 *
 * Placement: RentalReturnPage finalize-gate (a hívó köti az aláírás-státuszt a véglegesítéshez).
 */
export function ReturnSignButton({
  rentalId,
  rentalNumber,
  onSigned,
}: {
  rentalId: string;
  rentalNumber?: string | undefined;
  onSigned?: (() => void) | undefined;
}) {
  const { t } = useTranslation();
  const [signOpen, setSignOpen] = useState(false);

  return (
    <>
      <Button type="button" onClick={() => setSignOpen(true)} data-testid="return-sign-btn">
        {t('rental.return.signCta')}
      </Button>

      <SignContractDialog
        open={signOpen}
        onOpenChange={setSignOpen}
        contract={{ id: rentalId, contractNumber: rentalNumber ?? rentalId, type: 'rental-return' }}
        onSigned={() => {
          setSignOpen(false);
          onSigned?.();
        }}
      />
    </>
  );
}
